import Enlang from './entries/en-US';

export const AppLocale = {
  en: Enlang
};
